import styled from '@emotion/styled';

interface ContainerProps {
  noGap?: boolean;
  noMarginTop?: boolean;
  bgColor?: string;
}

//DESIGNED FOR ACTION & RESULT PAGES
export const PageContainer = styled.div`
  width: 100%;
  max-width: 1038px;
  margin: 24px auto;
  background-color:${({ bgColor }: ContainerProps) => (bgColor ||  "#ebebeb")}; ;
  display: flex;
  gap: ${({ noGap }: ContainerProps) => (noGap ? '0px' : '16px')};
  margin-top: ${({ noMarginTop }: ContainerProps) =>
    noMarginTop ? '0px' : '24px'};
  flex-direction: column;
`;
